// extracted by mini-css-extract-plugin
module.exports = {"container":"intro_container__AJL1e","profile":"intro_profile__2VPXk","image":"intro_image__3lLoH","caption":"intro_caption__2PZ_5","description":"intro_description__2Fxxo"};